<template>
  <div class="practice-tool">
    <div class="animate__animated animate__tada mb-6">
      <h1 class="text-center" style="color: #05ab33; text-shadow: 2px 2px 3px #8d8e8e; font-size:3rem !important; font-weight: bold;">プラクティスツール</h1>
    </div>
    <div class="container-fluid">

      <!-- 初回ダイアログ -->
      <el-dialog
        v-model="sw.fmDialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="99%"
      >
        <h2>【Step1】基本情報の入力</h2>
        <div class="form-group">
          <div>
            <label for="stock_target">投資対象</label>
            <el-select v-model="sw.stock_target"
                       @change="stockTargetInput()"
                       id="stock_target" placeholder="選択">
              <el-option
                v-for="item in stock_target_select"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div v-if="sw.stock_target==3">
            <p>※ 投資対象が「その他」のプラクティスについては小次郎講師のチェックの対象外です。</p>
          </div>
          <div>
            <el-checkbox style="display: inline-flex;" v-model="sw.funds_management"><span :class="{'text-primary': sw.funds_management}">＋ 資金管理</span></el-checkbox>
          </div>
        </div>

        <!-- + 資金管理欄 -->
        <transition name="fade" mode="out-in">
          <el-card shadow="always" class="form-group" v-if="sw.funds_management">
            <el-row :gutter="6">
              <el-col :xs="24" :sm="24" :lg="7" :class="errorClassObject('loss_cut_range')">
                <el-row :gutter="4">
                  <el-col :xs="24" :sm="8" :lg="13">
                    <label for="fm_loss_cut_range" class="control-label">ロスカット N-ATR</label>
                  </el-col>
                  <el-col :xs="24" :sm="16" :lg="11">
                    <el-input v-model="fm.loss_cut_range"
                              type="number" class="text-right" id="fm_loss_cut_range"
                              placeholder="1.0〜10.0" step="0.1" min="1" max="10" style="width: 90%;"></el-input>
                  </el-col>
                </el-row>
              </el-col>

              <el-col :xs="24" :sm="24" :lg="9" :class="errorClassObject('my_funds')">
                <el-row :gutter="4">
                  <el-col :xs="24" :sm="8" :lg="7">
                    <label for="fm_my_funds" class="control-label">投資用資金</label>
                  </el-col>
                  <el-col :xs="24" :sm="16" :lg="17">
                    <el-input v-model.number="fm.my_funds"
                              type="number" class="text-right" id="fm_my_funds"
                              placeholder="30万〜100億" min="300000" max="10000000000" style="width: 90%;">
                      <template #append>円</template>
                    </el-input>
                    <div class="help-block text-left">&nbsp;{{ my_funds_conv }}</div>
                  </el-col>
                </el-row>
              </el-col>

              <el-col :xs="24" :sm="24" :lg="7" :class="errorClassObject('unit_adjustment')">
                <el-row :gutter="4">
                  <el-col :xs="24" :sm="8" :lg="11">
                    <label for="fm_unit_adjustment" class="control-label">ユニットの調整</label>
                  </el-col>
                  <el-col :xs="24" :sm="16" :lg="13">
                    <el-input v-model="fm.unit_adjustment"
                              type="number" class="text-right" id="fm_unit_adjustment"
                              placeholder="0.1〜2.0" step="0.1" min="0.1" max="2" style="width: 90%;">
                    </el-input>
                  </el-col>
                </el-row>
              </el-col>

              <el-col :xs="24" :sm="24" :lg="1">
                <el-tooltip effect="dark" content="ヘルプ" placement="right">
                  <el-button class="help-button" type="primary" plain circle @click="sw.helpVisible = !sw.helpVisible"><span v-show="!sw.helpVisible">？</span><span v-show="sw.helpVisible">×</span></el-button>
                </el-tooltip>
              </el-col>
            </el-row>
          </el-card>
        </transition>

        <!-- + ヘルプ表示 -->
        <transition name="fade" mode="out-in">
          <practice-tool-help v-show="sw.helpVisible" :el-card-color-help="elCardColorHelp" :status="sw.status" v-on:help-close="sw.helpVisible = false"></practice-tool-help>
        </transition>

        <!-- 銘柄コード行 -->
        <el-card shadow="always" class="form-group">
          <el-row :gutter="6">
            <el-col :xs="24" :sm="12" :lg="6" :class="errorClassObject('brand_code')">
              <el-row :gutter="4">
                <el-col :xs="24" :sm="8" :lg="10">
                  <label for="brand_brand_code" class="control-label">銘柄コード</label>
                </el-col>
                <el-col :xs="24" :sm="16" :lg="14">
                  <div v-if="sw.stock_target==1">
                    <el-input v-model="brand.brand_code"
                              @input="brandCodeInput(brand.brand_code)"
                              type="number" class="text-right" id="brand_brand_code" placeholder="4桁" style="width: 90%;"></el-input>
                  </div>
                  <div v-else-if="sw.stock_target==2">
                    <el-select v-model="brand.brand_code"
                               @change="fxBrandCodeInput(brand.brand_code)"
                               id="fx_brand_brand_code" placeholder="選択" style="width: 90%;">
                      <el-option
                        v-for="(item, key) in m_fx_brands"
                        :key="key"
                        :label="key"
                        :value="key">
                      </el-option>
                    </el-select>
                  </div>
                  <div v-else-if="sw.stock_target==3">
                    <el-input value="なし" :disabled="true" style="width: 90%;"></el-input>
                  </div>
                </el-col>
              </el-row>
            </el-col>

            <el-col :xs="24" :sm="12" :lg="8" :class="errorClassObject('brand_name')">
              <el-row :gutter="4">
                <el-col :xs="24" :sm="8" :lg="5">
                  <label for="brand_brand_name" class="control-label">銘柄名</label>
                </el-col>
                <el-col :xs="24" :sm="16" :lg="19">
                  <div v-if="sw.stock_target==1 || sw.stock_target==2">
                    <span v-show="sw.brandLoading" class="text-secondary"><i class="el-icon-loading"></i>銘柄取得中...</span>
                    <span>{{brand.brand_name}}&nbsp;</span>
                  </div>
                  <div v-else-if="sw.stock_target==3">
                    <el-input v-model="brand.brand_name"
                              id="brand_brand_name" placeholder="入力" style="width: 90%;"></el-input>
                  </div>
                </el-col>
              </el-row>
            </el-col>

            <el-col :xs="24" :sm="12" :lg="4" :class="errorClassObject('chart')">
              <el-row :gutter="4">
                <el-col :xs="24" :sm="8" :lg="6">
                  <label for="brand_chart" class="control-label">足</label>
                </el-col>
                <el-col :xs="24" :sm="16" :lg="18">
                  <el-select v-model="brand.chart" id="brand_chart" placeholder="選択" style="width: 90%;">
                    <el-option
                      v-for="item in select_charts" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>

            <el-col :xs="24" :sm="12" :lg="6">
              <el-row :gutter="4">
                <el-col :xs="24" :sm="8" :lg="9">
                  <label for="key_currency_code" class="control-label">為替換算</label>
                </el-col>
                <el-col :xs="24" :sm="16" :lg="15">
                  <div v-if="sw.stock_target==1 || sw.stock_target==2">
                    <span class="no-wrap">&nbsp;{{brand.key_currency_code}}</span>
                  </div>
                  <div v-else-if="sw.stock_target==3">
                    <el-select v-model="brand.key_currency_code"
                               @change="currencyCodeInput(brand.key_currency_code)"
                               id="key_currency_code" placeholder="選択" style="width: 90%;">
                      <el-option
                        label="なし"
                        value="なし">
                      </el-option>
                      <el-option
                        v-for="(item, key) in m_fx_brands"
                        :key="key"
                        :label="key"
                        :value="key">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-card>

        <!-- エラーメッセージ -->
        <transition-group
          name="custom-classes-transition"
          enter-active-class="animate__animated animate__flipInX"
          leave-active-class="animate__animated animate__flipOutX"
          mode="out-in"
        >
          <div v-for="errMsg in isErrMsg" :key="errMsg">
            <el-alert
              :title="errMsg"
              type="error"
              center
              :closable="false"
              show-icon>
            </el-alert>
          </div>
        </transition-group>

        <!-- ダイアログボタン -->
        <template #footer>
          <el-button type="primary" plain round :disabled="!isValid" @click="fmSubmit()">入力完了</el-button>
        </template>
      </el-dialog>
      <!-- /初回ダイアログここまで -->

      <!-- 講師コメントと評価 -->
      <div v-show="sw.status === 'submitted'">
        <el-row v-show="instructor_comment || evaluation" class="form-group">
          <el-col v-if="evaluation" :span="4" class="mr-6">
            <img :src="getImage(config.evaluations[evaluation].image)" :alt="config.evaluations[evaluation].name" class="img-evaluation">
          </el-col>
          <el-col v-show="instructor_comment" :span="18" class="comment">
            <div style="white-space: pre-wrap;" v-text="instructor_comment"></div>
          </el-col>
        </el-row>
      </div>
      <!-- /講師コメントここまで -->

      <!-- ボタングループ -->
      <div v-show="sw.status !== 'submitted'" class="form-group">
        <el-button class="margin-right-10" type="success" plain @click="callSaveData()">保存</el-button>
        <el-button class="margin-right-10" style="margin-left:0px;" type="warning" plain @click="sw.submitDialogVisible = true">提出</el-button>
        <el-dialog
          title="提出の確認"
          v-model="sw.submitDialogVisible"
          width="50%">
          <span>
            <strong>提出</strong>すると、<span class="text-danger">「感想と備忘録」以外の編集ができなくなります</span>。
            <br>
            <br><strong><span class="text-warning">本当に提出してもよろしいですか？</span></strong>
            <br>
            <br>※手仕舞いまで入力が完了していない行は<span class="text-danger">破棄</span>されます。
            <br>※提出後のプラクティスは会員サイトの提出済み一覧からご覧いただけます。
          </span>
          <template #footer>
            <div>
              <el-button type="warning" plain @click="submission()">はい</el-button>
              <el-button type="" plain @click="sw.submitDialogVisible = false">いいえ</el-button>

              <el-card class="margin-ud-10 text-left" shadow="always">
                <label>感想と備忘録</label>
                <el-input
                  type="textarea"
                  v-model="appendix.memo"
                  class="el-control"
                  :autosize="{ minRows: 4}">
                </el-input>
              </el-card>
            </div>
          </template>

        </el-dialog>
        <el-button class="margin-right-10" type="danger" plain @click="sw.trashDialogVisible = true">破棄</el-button>
        <el-dialog
          title="注意"
          v-model="sw.trashDialogVisible"
          width="50%">
          <span>
            <strong>破棄</strong>すると、また新しくプラクティスを開始できます。
            <br>
            <br>ただし、<strong>現在このページで編集中の内容や、一旦保存したデータも削除されます</strong>
            <br>
            <br>よくご確認の上、破棄をおこなって下さい。
            <br>
            <br><span class="text-danger">本当に破棄してもよろしいですか？</span>
          </span>
          <template #footer>
            <span>
              <el-button type="danger" plain @click="trash()">はい</el-button>
              <el-button type="" plain @click="sw.trashDialogVisible = false">いいえ</el-button>
            </span>
          </template>
        </el-dialog>
      </div>

      <!-- *** 以降、表より上側は細かい調整のためにelement-uiのグリッドを使用しています（24カラム） *** -->
      <!-- + 資金管理欄 -->
      <div v-if="sw.funds_management" class="fusen">
        <el-row>
          <el-col :lg="18" :xl="12">
            <div class="table-responsive">
              <table class="h-table" style="height: 176px; color: #000;">
                <tbody>
                  <tr>
                    <th class="rbar"><span>ロスカット N-ATR</span></th>
                    <td class="data fst" style="width: 25%">
                      <span>{{ fm.loss_cut_range }}</span>
                    </td>
                    <th class="rbar lbar"><span>投資用資金</span></th>
                    <td class="data fst" style="width: 25%">
                      <span>{{ moneyDelimiter(fm.my_funds) }}円</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="bar" colspan="4"></td>
                  </tr>
                  <tr>
                    <th class="rbar"><span>ユニットの調整 (D)</span></th>
                    <td class="data fst" style="width: 25%">
                      <span>{{ fm.unit_adjustment }}</span>
                    </td>
                    <th class="rbar lbar"><span>投資用資金の1% (A)</span></th>
                    <td class="data fst" style="width: 25%">
                      <span>{{ moneyDelimiter(my_funds_in_calc) }}円</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="bar" colspan="4"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </el-col>
          <el-tooltip effect="dark" content="ヘルプ" placement="right">
            <el-button class="help-button" type="primary" plain circle @click="sw.helpVisible = !sw.helpVisible"><span v-show="!sw.helpVisible">？</span><span v-show="sw.helpVisible">×</span></el-button>
          </el-tooltip>
        </el-row>
      </div>

      <transition name="fade" mode="out-in">
        <practice-tool-help v-show="sw.helpVisible" :el-card-color-help="elCardColorHelp" :status="sw.status" v-on:help-close="sw.helpVisible = false"></practice-tool-help>
      </transition>

      <!-- 銘柄コード行 -->
      <div class="fusen">
        <div class="table-responsive">
          <table class="h-table" style="height: 30px; color: #000;">
            <tbody>
              <tr>
                <th class="rbar"><span>銘柄コード</span></th>
                <td class="data fst">
                  <span>{{ brand.brand_code }}</span>
                </td>
                <th class="rbar lbar"><span>銘柄名</span></th>
                <td class="data fst">
                  <span>{{ brand.brand_name }}</span>
                </td>
                <th class="rbar lbar"><span>足</span></th>
                <td class="data fst">
                  <span>{{ fetchChartLabel }}</span>
                </td>
                <th class="rbar lbar"><span>為替換算 (C)</span></th>
                <td class="data fst">
                  <div v-if="brand.key_currency_code=='なし'">
                    <span>{{ brand.key_currency_code }}</span>
                  </div>
                  <div v-else>
                    <span>{{ brand.key_currency_code }}（{{brand.kawase}}）</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 勝ち負け -->
      <transition name="fade" mode="out-in">
        <div v-show="sw.status === 'submitted'" class="kokuban form-group">

          <div class="table-responsive">
            <table class="h-table" style="height: 50px; color: #fff; text-shadow: 1px 1px 3px #000;">
              <tbody>
                <tr>
                  <th class="rbar"><span>勝ち数</span></th>
                  <td class="data fst">
                    <span>{{ result.win_cnt }}</span>
                  </td>
                  <th class="rbar lbar"><span>利益平均</span></th>
                  <td class="data fst">
                    <span>{{ moneyDelimiter(result.profit_average) }}</span>
                  </td>
                  <th class="rbar lbar"><span>勝率</span></th>
                  <td class="data fst">
                    <span>{{ result.win_rate }}%</span>
                  </td>
                  <th class="rbar lbar">
                    <span>トレード回数</span>
                  </th>
                  <td class="data fst">
                    <span>{{ result.trade_count }}</span>
                  </td>
                  <th class="rbar lbar">
                    <span>累計損益</span>
                  </th>
                  <td class="data fst">
                    <span :class="{'text-red': result.accumulated_profit_loss < 0}">{{ moneyDelimiter(result.accumulated_profit_loss) }}円</span>
                  </td>
                </tr>
                <tr>
                  <td class="bar" colspan="10"></td>
                </tr>
                <tr>
                  <th class="rbar"><span>負け数</span></th>
                  <td class="data fst">
                    <span>{{ result.lose_cnt }}</span>
                  </td>
                  <th class="rbar lbar"><span>損失平均</span></th>
                  <td class="data fst">
                    <span :class="{'text-red': result.loss_average < 0}">{{ moneyDelimiter(result.loss_average) }}</span>
                  </td>
                  <th class="rbar lbar"><span>リスクリワード比率</span></th>
                  <td class="data fst">
                    <span :class="{'text-red': result.risk_reword_ratio < 0}">{{ result.risk_reword_ratio }}</span>
                  </td>
                  <th class="rbar lbar">
                    <span>トレードエッジ</span>
                  </th>
                  <td class="data fst">
                    <span>{{ moneyDelimiter(result.trade_edge) }}</span>
                  </td>
                  <!-- + 資金管理のみ -->
                  <th class="rbar lbar" v-if="sw.funds_management"><span>累計損益%</span></th>
                  <td class="data fst"  v-if="sw.funds_management">
                    <span :class="{'text-red': result.percent_total_profit_loss < 0}">{{ result.percent_total_profit_loss }}%</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </transition>

      <!-- 表部分 -->
      <div class="form-group">
        <div class="table-responsive">
          <table class="table table-bordered table-hover table-striped">
            <thead>
              <tr>
                <th :colspan="colspanStep2" class="step2-color border-right"><div>仕掛け</div></th>
                <th v-if="sw.funds_management" rowspan="2" class="system-color border-right"><div>ロスカット</div></th>
                <th :colspan="colspanStep3" class="step3-color border-right"><div>手仕舞い</div></th>
                <th rowspan="2" class="system-color"><div>獲得値幅</div></th>
                <th v-if="sw.stock_target==2" rowspan="2" class="system-color"><div>pips</div></th>
                <th v-if="sw.funds_management" rowspan="2" class="system-color"><div>値幅／<br>ATR</div></th>
                <th rowspan="2" class="system-color"><div>取引損益</div></th>
                <th v-if="sw.funds_management" rowspan="2" class="system-color"><div>残高</div></th>
              </tr>
              <tr>
                <th class="step2-color"><div>日付</div></th>
                <th v-if="brand.chart && brand.chart < 1440" class="step2-color"><div>時刻</div></th>
                <th v-if="sw.funds_management" class="step2-color"><div>ATR(B)</div></th>
                <th class="step2-color"><div>取引量</div></th>
                <th class="step2-color"><div>買/売</div></th>
                <th class="step2-color"><div>価格</div></th>
                <th class="step2-color border-right" style="min-width: 285px;"><div>理由</div></th>
                <th class="step3-color"><div>日付</div></th>
                <th v-if="brand.chart && brand.chart < 1440" class="step3-color"><div>時刻</div></th>
                <th class="step3-color"><div>価格</div></th>
                <th class="step3-color border-right" style="min-width: 285px;"><div>理由</div></th>
              </tr>
            </thead>
            <transition-group
              name="custom-classes-transition"
              enter-active-class="animate__animated animate__fadeInLeft"
              leave-active-class="animate__animated animate__fadeInRight"
              mode="out-in"
              tag="tbody"
            >
              <tr v-for="row in rows" :key="row.row_id" track-by="$index">
                <!-- * 仕掛け 日付 * -->
                <td>
                  <div class="text-center no-wrap">{{ row.step2_date }}</div>
                </td>
                <!-- * 仕掛け 時間 +足が日足未満 * -->
                <td v-if="brand.chart && brand.chart < 1440">
                  <div class="text-left no-wrap">{{ row.step2_time }}</div>
                </td>
                <!-- * 仕掛け ATR(B) +sw.funds_management * -->
                <td v-if="sw.funds_management">
                  <div class="text-right no-wrap">{{ row.step2_atr }}</div>
                </td>
                <!-- * 仕掛け 取引量 * -->
                <td>
                  <div class="text-right no-wrap">{{ row.step2_trading_volume }}</div>
                </td>
                <!-- * 仕掛け 買/売 * -->
                <td>
                  <div class="text-center no-wrap">{{ fetchTradingLabel(row.step2_trading) }}</div>
                </td>
                <!-- * 仕掛け 価格 * -->
                <td>
                  <div class="text-right no-wrap">{{ notRoundMoneyDelimiter(row.step2_price) }}</div>
                </td>
                <!-- * 仕掛け 理由 * -->
                <td class="border-right">
                  <div class="text-left">{{ row.step2_reason }}</div>
                </td>
                <!-- * ロスカット +sw.funds_management * -->
                <td v-if="sw.funds_management" class="border-right" :class="classCellColor(row.loss_cut, 0)">
                  <div class="text-right no-wrap">{{ row.loss_cut }}</div>
                </td>
                <!-- * 手仕舞い 日付 * -->
                <td>
                  <div class="text-center no-wrap">{{ row.step3_date }}</div>
                </td>
                <!-- * 仕掛け 時間 +足が日足未満 * -->
                <td v-if="brand.chart && brand.chart < 1440">
                  <div class="text-left no-wrap">{{ row.step3_time }}</div>
                </td>
                <!-- * 手仕舞い 価格 * -->
                <td>
                  <div class="text-right no-wrap">{{ notRoundMoneyDelimiter(row.step3_price) }}</div>
                </td>
                <!-- * 手仕舞い 理由 * -->
                <td class="border-right">
                  <div class="text-left">{{ row.step3_reason }}</div>
                </td>
                <!-- * 獲得値幅 * -->
                <td :class="classCellColor(row.profit_loss_per_share, 0)">
                  <div class="text-right no-wrap">{{ notRoundMoneyDelimiter(row.profit_loss_per_share) }}</div>
                </td>
                <!-- * pips * -->
                <td v-if="sw.stock_target==2" :class="classCellColor(row.pips, 0)">
                  <div class="text-right no-wrap">{{ moneyDelimiter(row.pips) }}</div>
                </td>
                <!-- * 値幅／ATR * -->
                <td v-if="sw.funds_management" :class="classCellColor(row.profit_loss_atr, 0)">
                  <div class="text-right no-wrap">{{ row.profit_loss_atr }}</div>
                </td>
                <!-- * 取引損益 * -->
                <td :class="classCellColor(row.trading_profit_loss, 0)">
                  <div class="text-right no-wrap">{{ moneyDelimiter(row.trading_profit_loss) }}円</div>
                </td>
                <!-- * 残高 * -->
                <td v-if="sw.funds_management" :class="classCellColor(row.balance, fm.my_funds)">
                  <div class="text-right no-wrap">{{ moneyDelimiter(row.balance) }}円</div>
                </td>
              </tr>
            </transition-group>
          </table>
        </div>
      </div>

      <!-- 切り替えるごとに点滅させたいだけ -->
      <div v-show="sw.status === 'step2'" class="form-group animate__animated animate__flash">
        <div class="up"></div>
      </div>
      <div v-show="sw.status === 'step3'" class="form-group animate__animated animate__flash">
        <div class="up"></div>
      </div>

      <transition-group
        name="custom-classes-transition"
        enter-active-class="animate__animated animate__zoomInUp"
        leave-active-class="animate__animated animate__flipOutX"
        mode="out-in"
      >
        <el-card v-if="sw.status === 'step2'" class="form-group" shadow="always" key="step2">
          <h2>【Step2】仕掛けの入力</h2>
          ※日付は古いものから順に挿入してください。

          <div class="table-responsive">
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th class="step2-color" :colspan="colspanStep2"><div>仕掛け</div></th>
                </tr>
                <tr>
                  <th class="step2-color" width="180"><div>日付</div></th>
                  <th class="step2-color" width="180" v-if="brand.chart && brand.chart < 1440"><div>時刻</div></th>
                  <th v-if="sw.funds_management" class="step2-color" style="min-width: 200px;" width="200"><div>ATR(B)</div></th>
                  <th class="step2-color" style="min-width: 200px;" width="200"><div>取引量</div></th>
                  <th class="step2-color" style="min-width: 117px;" width="117"><div>買/売</div></th>
                  <th class="step2-color" style="min-width: 200px;" width="200"><div>価格</div></th>
                  <th class="step2-color" style="min-width: 332px;"><div>理由</div></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <!-- * 仕掛け 日付 * -->
                  <td>
                    <div :class="errorClassObjectStep2('step2_date')">
                      <el-date-picker
                        type="date"
                        v-model="inputStep2.step2_date"
                        class="el-control"
                        style="max-width: 180px;"
                        value-format="YYYY-MM-DD"
                        placeholder="日付選択">
                      </el-date-picker>
                    </div>
                  </td>
                  <!-- * 仕掛け 時間 +足が日足未満 * -->
                  <td v-if="brand.chart && brand.chart < 1440">
                    <div :class="errorClassObjectStep2('step2_time')">
                      <el-time-picker
                        type="time"
                        v-model="inputStep2.step2_time"
                        class="el-control"
                        style="max-width: 180px;"
                        value-format="HH:mm"
                        format="HH:mm"
                        :picker-options="{
                          format: 'HH:mm'
                        }"
                        placeholder="時刻選択">
                      </el-time-picker>
                    <!-- :picker-options="{
                                                    selectableRange: '9:00:00 - 15:00:00'
                                                }" -->
                    </div>
                  </td>
                  <!-- * 仕掛け ATR(B) +sw.funds_management * -->
                  <td v-if="sw.funds_management">
                    <div :class="errorClassObjectStep2('step2_atr')">
                      <el-input
                        type="number"
                        v-model="inputStep2.step2_atr"
                        class="text-right form-control"
                        placeholder="ATR(B)"></el-input>
                    </div>
                  </td>
                  <!-- * 仕掛け 取引量 * -->
                  <td>
                    <div :class="errorClassObjectStep2('step2_trading_volume')">
                      <el-input
                        type="number"
                        v-model.number="inputStep2.step2_trading_volume"
                        class="text-right form-control"
                        placeholder="取引量"></el-input>
                    </div>
                  </td>
                  <!-- * 仕掛け 買/売 * -->
                  <td>
                    <div :class="errorClassObjectStep2('step2_trading')">
                      <el-select
                        v-model="inputStep2.step2_trading"
                        class="el-control"
                        placeholder="買/売">
                        <el-option
                          v-for="item in trading_options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </td>
                  <!-- * 仕掛け 価格 * -->
                  <td>
                    <div :class="errorClassObjectStep2('step2_price')">
                      <el-input
                        type="number"
                        v-model="inputStep2.step2_price"
                        class="form-control text-right"
                        placeholder="価格"></el-input>
                    </div>
                  </td>
                  <!-- * 仕掛け 理由 * -->
                  <td>
                    <div :class="errorClassObjectStep2('step2_reason')">
                      <el-input
                        type="textarea"
                        v-model="inputStep2.step2_reason"
                        class="el-control"
                        autosize
                        placeholder="理由">
                      </el-input>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- ユニットサイズ -->
          <el-row v-if="sw.funds_management">
            <el-col :span="5">
              <div class="fusen">
                <table class="h-table" style="height: 50px;">
                  <tbody>
                    <tr>
                      <th class="rbar"><span>ユニットサイズ (A÷(B×C)×D)</span></th>
                      <td class="data fst">
                        <span>{{ unit_size_calc }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <!-- エラーメッセージ -->
            <div v-show="isErrMsg" class="form-group" style="width:100%;">
              <transition-group
                name="custom-classes-transition"
                enter-active-class="animate__animated animate__flipInX"
                leave-active-class="animate__animated animate__flipOutX"
                mode="out-in"
              >
                <div v-for="errMsg in isErrMsg" :key="errMsg">
                  <el-alert
                    :title="errMsg"
                    type="error"
                    center
                    :closable="false"
                    show-icon>
                  </el-alert>
                </div>
              </transition-group>
            </div>

            <div v-if="latestRowIndex > 0" class="btn-center2">
              <el-button class="margin-right-10" type="primary" plain @click="backToTheStep3()">手仕舞いへ戻る</el-button>
              <el-button class="margin-right-10" type="danger" plain @click="step2Submit()">仕掛け挿入</el-button>
            </div>
            <div v-else class="btn-center">
              <el-button class="margin-right-10" type="danger" plain @click="step2Submit()">仕掛け挿入</el-button>
            </div>
          </el-row>

        </el-card>

        <el-card v-if="sw.status === 'step3'" class="form-group" shadow="always" key="step3">
          <h2>【Step3】手仕舞いの入力</h2>

          <div class="table-responsive">
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th :colspan="colspanStep3" class="step3-color"><div>手仕舞い</div></th>
                </tr>
                <tr>
                  <th class="step3-color" width="180"><div>日付</div></th>
                  <th class="step3-color" width="180" v-if="brand.chart && brand.chart < 1440"><div>時刻</div></th>
                  <th class="step3-color" style="min-width: 200px;" width="300"><div>価格</div></th>
                  <th class="step3-color" style="min-width: 332px;"><div>理由</div></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <!-- * 手仕舞い 日付 * -->
                  <td>
                    <div :class="errorClassObjectStep3('step3_date')">
                      <el-date-picker
                        type="date"
                        v-model="inputStep3.step3_date"
                        class="el-control"
                        style="max-width: 180px;"
                        value-format="YYYY-MM-DD"
                        placeholder="日付選択">
                      </el-date-picker>
                    </div>
                  </td>
                  <!-- * 手仕舞い 時間 +足が日足未満 * -->
                  <td v-if="brand.chart && brand.chart < 1440">
                    <div :class="errorClassObjectStep3('step3_time')">
                      <el-time-picker
                        type="time"
                        v-model="inputStep3.step3_time"
                        class="el-control"
                        style="max-width: 180px;"
                        value-format="HH:mm"
                        format="HH:mm"
                        :picker-options="{
                          format: 'HH:mm'
                        }"
                        placeholder="時刻選択">
                      </el-time-picker>
                    <!-- :picker-options="{
                                                    selectableRange: '9:00:00 - 15:00:00'
                                                }" -->
                    </div>
                  </td>
                  <!-- * 手仕舞い 価格 * -->
                  <td>
                    <div :class="errorClassObjectStep3('step3_price')">
                      <el-input
                        type="number"
                        v-model="inputStep3.step3_price"
                        class="text-right form-control"
                        placeholder="価格"></el-input>
                    </div>
                  </td>
                  <!-- * 手仕舞い 理由 * -->
                  <td>
                    <div :class="errorClassObjectStep3('step3_reason')">
                      <el-input
                        type="textarea"
                        v-model="inputStep3.step3_reason"
                        class="el-control"
                        autosize
                        placeholder="理由">
                      </el-input>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <el-row>
            <!-- エラーメッセージ -->
            <div v-show="isErrMsg" class="form-group" style="width:100%;">
              <transition-group
                name="custom-classes-transition"
                enter-active-class="animate__animated animate__flipInX"
                leave-active-class="animate__animated animate__flipOutX"
                mode="out-in"
              >
                <div v-for="errMsg in isErrMsg" :key="errMsg">
                  <el-alert
                    :title="errMsg"
                    type="error"
                    center
                    :closable="false"
                    show-icon>
                  </el-alert>
                </div>
              </transition-group>
            </div>

            <div class="btn-center2">
              <el-button class="margin-right-10" type="danger" plain @click="backToTheStep2()">仕掛け入力</el-button>
              <el-button class="margin-right-10" type="primary" plain @click="step3Submit()">手仕舞い挿入</el-button>
            </div>
          </el-row>

        </el-card>
      </transition-group>

      <el-card class="form-group" shadow="always">
        <label>感想と備忘録</label>
        <el-input
          type="textarea"
          v-model="appendix.memo"
          class="el-control"
          :autosize="{ minRows: 4}">
        </el-input>

        <!-- 感想と備忘録保存用 -->
        <div class="btn-right">
          <el-button v-if="sw.status === 'submitted'" class="btn-right" type="success" plain @click="updateData()">保存</el-button>
        </div>
      </el-card>

    </div>
  </div>
</template>

<script>
import { ElMessageBox, ElMessage, ElLoading } from 'element-plus'
import { axios } from '@/plugins/axios'
import PracticeToolHelp from '@/components/tools/PracticeToolHelp.vue'
import { dayjs } from '@/plugins/dayjs'

export const evaluations = {
  1: {
    name: 'Excellent',
    image: 'evaluation_1.gif'
  },
  2: {
    name: 'Very good',
    image: 'evaluation_2.png'
  },
  3: {
    name: 'good',
    image: 'evaluation_3.png'
  },
  4: {
    name: 'ファイト！',
    image: 'evaluation_4.png'
  },
}

export default {
  data() {
    return {
      // rows以外の動的データのセットはinitData()で行います。
      // *--- スイッチ周り ---*
      sw: {},
      // *--- + 資金管理 ---*
      fm: {},
      // *--- 銘柄入力行 ---*
      brand: {},
      // *--- 仕掛け／手仕舞い入力 ---*
      inputStep2: {},
      inputStep3: {},
      // *--- 提出後結果 ---*
      result: {},
      // *--- 仕掛け／手仕舞い表部分 ---*
      rows: this.initRow(),
      // *--- 感想と備忘録 ---*
      appendix: {},
      // *--- 提出したプラクティスに対する評価と講師コメント ---*
      config: {
        evaluations: evaluations // 評価config
      },
      evaluation: '', // 提出以降につける評価、とくに破棄など必要ないのでinitData()に含めない
      instructor_comment: '', // 提出以降につけるコメント、とくに破棄など必要ないのでinitData()に含めない
      // *--- 固定値 ---*
      elCardColor: { 'background-color': '#91ea94' }, // el-card色変
      elCardColorHelp: { 'background-color': '#e9f4fb' }, // el-card色変
      step2_max_cols: 7, // テーブルヘッダ調整用
      step3_max_cols: 4, // テーブルヘッダ調整用
      trading_options: [
        { value: 1, label: '買' },
        { value: -1, label: '売' },
      ],
      select_charts: [
        { value: 1440, label: '日足' },
        { value: 240, label: '4時間足' },
        { value: 180, label: '3時間足' },
        { value: 120, label: '2時間足' },
        { value: 60, label: '1時間足' },
        { value: 45, label: '45分足' },
        { value: 30, label: '30分足' },
        { value: 15, label: '15分足' },
        { value: 5, label: '5分足' },
        { value: 3, label: '3分足' },
        { value: 1, label: '1分足' },
      ],
      validates: {
        fm: {
          loss_cut_range_min: 1, // ロスカット幅最小
          loss_cut_range_max: 10, // ロスカット幅最大
          my_funds_min: 300000, // 自分の投資用資金最小
          my_funds_max: 10000000000, // 自分の投資用資金最大
          unit_adjustment_min: 0.1, // ユニットの調整 (C)最小
          unit_adjustment_max: 2, // ユニットの調整 (C)最大
        },
        brand: {
          brand_code_length: 4, // 検証用 銘柄コード長
          fx_brand_code_length: 7,
        },
      },
      saved_practice_id: '', // 提出直後にpractice_idが必要なため。
      stock_target_select: [
        { value: 1, label: '株' },
        { value: 2, label: 'FX' },
        { value: 3, label: 'その他' },
      ],
      m_fx_brands: '',
      org_round_list: [
        { value: 0, base: 0 },
        { value: 1, base: 10 },
        { value: 2, base: 100 },
        { value: 3, base: 1000 },
        { value: 4, base: 10000 },
        { value: 5, base: 100000 },
        { value: 6, base: 1000000 },
        { value: 7, base: 10000000 },
        { value: 8, base: 100000000 },
        { value: 9, base: 1000000000 },
        { value: 10, base: 10000000000 },
      ],
    }
  },
  computed: {
    // *--- 入力金額が見辛いので変換 ---*
    my_funds_conv() {
      let str = ''
      let result
      result = this.fm.my_funds
      if (!result || result < 1) {
        return ''
      }
      if (result >= 100000000) {
        result = result / 100000000
        str += '億円'
      } else if (result >= 10000) {
        result = result / 10000
        str += '万円'
      } else {
        str += '円'
      }
      return result.toLocaleString() + str
    },
    // *--- バリデーション（step1） ---*
    validation() {
      const my_funds = this.fm.my_funds,
        loss_cut_range = this.fm.loss_cut_range,
        unit_adjustment = this.fm.unit_adjustment

      const brand_code = this.brand.brand_code,
        brand_name = this.brand.brand_name,
        chart = this.brand.chart

      let brand_code_validation = ''
      let brand_name_validation = ''
      // 投資対象判定
      if (this.sw.stock_target==1) {
        brand_code_validation = {
          require: [!!brand_code, '銘柄コードを入力しましょう。'],
          notfound: [!!brand_name, '正しい銘柄コードを入力してください'],
          length: [brand_code.length === this.validates.brand.brand_code_length, '銘柄コードは'+this.validates.brand.brand_code_length+'桁でなくてはなりません。'],
        }
        brand_name_validation = {
          require: [true, ''],
        }
      }
      else if (this.sw.stock_target==2) {
        brand_code_validation = {
          require: [!!brand_code, '銘柄コードを選択しましょう。'],
        }
        brand_name_validation = {
          require: [true, ''],
        }
      }
      else if (this.sw.stock_target==3) {
        brand_code_validation = {
          require: [true, ''],
        }
        brand_name_validation = {
          require: [!!brand_name, '銘柄名を入力しましょう。'],
        }
      }

      return {
        my_funds: (this.sw.funds_management)
          ?
          {
            require: [!!my_funds, '投資用資金を入力しましょう'],
            min: [my_funds >= this.validates.fm.my_funds_min, '投資用資金は'+this.validates.fm.my_funds_min+'以上にしましょう。'],
            max: [my_funds <= this.validates.fm.my_funds_max, '投資用資金は'+this.validates.fm.my_funds_max+'以下にしましょう。']
          }
          :
          {
            require: [true, ''],
          },
        loss_cut_range: (this.sw.funds_management)
          ?
          {
            require: [!!loss_cut_range, 'ロスカットを入力しましょう。'],
            min: [loss_cut_range >= this.validates.fm.loss_cut_range_min, 'ロスカットは'+this.validates.fm.loss_cut_range_min+'以上にしましょう。'],
            max: [loss_cut_range <= this.validates.fm.loss_cut_range_max, 'ロスカットは'+this.validates.fm.loss_cut_range_max+'以下にしましょう。']
          }
          :
          {
            require: [true, ''],
          },
        unit_adjustment: (this.sw.funds_management)
          ?
          {
            require: [!!unit_adjustment, 'ユニットの調整を入力しましょう。'],
            min: [unit_adjustment >= this.validates.fm.unit_adjustment_min, 'ユニットの調整は'+this.validates.fm.unit_adjustment_min+'以上にしましょう。'],
            max: [unit_adjustment <= this.validates.fm.unit_adjustment_max, 'ユニットの調整は'+this.validates.fm.unit_adjustment_max+'以下にしましょう。']
          }
          :
          {
            require: [true, ''],
          },
        brand_code: brand_code_validation,
        brand_name: brand_name_validation,
        chart:
                    {
                      require: [!!chart, '足を選択しましょう。'],
                    },
      }

    },
    // *--- バリデーション（step2） ---*
    step2Validation() {
      const step2_date = this.inputStep2.step2_date,
        step2_trading_volume = this.inputStep2.step2_trading_volume,
        step2_trading = this.inputStep2.step2_trading,
        step2_price = this.inputStep2.step2_price,
        step2_reason = this.inputStep2.step2_reason,
        step2_atr = this.inputStep2.step2_atr,
        step2_time = this.inputStep2.step2_time

      return {
        step2_date:
                    {
                      require: [!!step2_date, '日付を選択しましょう。'],
                      old: [
                        (this.latestRowIndex > 0)
                          ? step2_date >= this.rows[this.latestRowIndex - 1].step2_date
                          : true,
                        '前行の仕掛け日付より前になってはいけません。'
                      ]
                    },
        step2_trading_volume:
                    {
                      require: [!!step2_trading_volume, '取引量を入力しましょう。'],
                      integer: [Number.isInteger(step2_trading_volume) === true, '取引量は整数にしてください。小数点を含んではいけません。'],
                      unsigned: [step2_trading_volume >= 0, '取引量は0以上にしましょう。'],
                      max: [step2_trading_volume <= this.validates.fm.my_funds_max, '取引量は'+this.validates.fm.my_funds_max+'以下にしましょう。'] // 一応
                    },
        step2_trading:
                    {
                      require: [!!step2_trading, '買/売を入力しましょう。'],
                    },
        step2_price:
                    {
                      require: [!!step2_price, '価格を入力しましょう。'],
                      max: [step2_price <= this.validates.fm.my_funds_max, '価格は'+this.validates.fm.my_funds_max+'以下にしましょう。'] // 一応
                    },
        step2_reason:
                    {
                      require: [!!step2_reason, '理由を入力しましょう。'],
                    },
        step2_atr: (this.sw.funds_management)
          ?
          {
            require: [!!step2_atr, 'ATRを入力しましょう。'],
            max: [step2_atr <= this.validates.fm.my_funds_max, 'ATRは'+this.validates.fm.my_funds_max+'以下にしましょう。'] // 一応
          }
          :
          {
            require: [true, ''],
          },
        step2_time: (this.brand.chart && this.brand.chart < 1440)
          ?
          {
            require: [!!step2_time, '時刻を選択しましょう。'],
            old: [
              (this.latestRowIndex > 0)
                ? step2_date > this.rows[this.latestRowIndex - 1].step2_date ||
                                  step2_date == this.rows[this.latestRowIndex - 1].step2_date &&
                                  step2_time >= this.rows[this.latestRowIndex - 1].step2_time
                : true,
              '前行の仕掛け日時より前になってはいけません。'
            ],
          }
          :
          {
            require: [true, ''],
          },
      }
    },
    // *--- バリデーション（step2） ---*
    step3Validation() {
      const step3_date = this.inputStep3.step3_date,
        step3_price = this.inputStep3.step3_price,
        step3_reason = this.inputStep3.step3_reason,
        step3_time = this.inputStep3.step3_time

      return {
        step3_date:
                    {
                      require: [!!step3_date, '日付を選択しましょう。'],
                      old: [step3_date >= this.rows[this.latestRowIndex].step2_date, '仕掛け日付より前になってはいけません。']
                    },
        step3_price:
                    {
                      require: [!!step3_price, '価格を入力しましょう。'],
                      max: [step3_price <= this.validates.fm.my_funds_max, '価格は'+this.validates.fm.my_funds_max+'以下にしましょう。'] // 一応
                    },
        step3_reason:
                    {
                      require: [!!step3_reason, '理由を入力しましょう。'],
                    },
        step3_time: (this.brand.chart && this.brand.chart < 1440)
          ?
          {
            require: [!!step3_time, '時刻を選択しましょう。'],
            old: [
              step3_date > this.rows[this.latestRowIndex].step2_date ||
                            step3_date == this.rows[this.latestRowIndex].step2_date &&
                            step3_time >= this.rows[this.latestRowIndex].step2_time,
              '仕掛け日時より前になってはいけません。'
            ],
          }
          :
          {
            require: [true, ''],
          },
      }
    },
    // *--- ステップ毎の全バリデーション ---*
    isValid() {
      let validation = null
      switch (this.sw.status) {
      case 'step1': validation = this.validation; break
      case 'step2': validation = this.step2Validation; break
      case 'step3': validation = this.step3Validation; break
      default: return
      }
      return Object.keys(validation).every(iKey => {
        return Object.keys(validation[iKey]).every(jKey => {
          return validation[iKey][jKey][0]
        })
      })
    },
    isErrMsg() {
      let validation = null
      switch (this.sw.status) {
      case 'step1': validation = this.validation; break
      case 'step2': validation = this.step2Validation; break
      case 'step3': validation = this.step3Validation; break
      default: return
      }
      let errorMsg = []
      for (let iKey in validation) {
        let count = 0
        for (let jKey in validation[iKey]) {
          if (validation[iKey][jKey][0] === false && count === 0)
          {
            errorMsg.push(validation[iKey][jKey][1])
            count++ // 同じikeyのメッセージなら1個だけがいいのだ
          }
        }
      }
      return errorMsg
    },
    // *--- ユニットサイズ計算 ---*
    unit_size_calc() {
      let result = 0
      if (this.my_funds_in_calc && this.inputStep2.step2_atr && this.brand.kawase && this.fm.unit_adjustment) {
        result = this.orgRound(
          this.my_funds_in_calc / (this.inputStep2.step2_atr * this.brand.kawase) * this.fm.unit_adjustment,
          1
        )
      }
      return result
    },
    // *--- 投資用資金の1%計算 ---*
    my_funds_in_calc() {
      return this.orgRound(
        // this.adjusted_fund_calc / 100,
        this.fm.my_funds / 100,
        1
      )
    },
    // *--- チャートラベルの取得 ---*
    fetchChartLabel() {
      const find = this.select_charts.filter((item, index) => {
        if (item.value === this.brand.chart) { return true }
      })
      return (find[0]) ? find[0].label : ''
    },
    // *--- 最新行のindex返却 ---*
    latestRowIndex() {
      return this.rows.length - 1
    },
    // *--- Table カラム調整 ---*
    colspanStep2() {
      let col = this.step2_max_cols
      if (!this.sw.funds_management) { col -= 1 }
      if (!this.brand.chart || this.brand.chart === 1440) { col -= 1 }
      return col
    },
    colspanStep3() {
      let col = this.step3_max_cols
      if (!this.brand.chart || this.brand.chart === 1440) { col -= 1 }
      return col
    },
  },
  async created() {
    const loadingInstance = ElLoading.service()

    this.initData()
    await this.fetchData(this.$route.params.id)

    /******************************
     * 下記処理の説明
     * 提出リスト側の勝率等々の再計算を省くため、提出時に計算して保存しています。
     * しかし計算を変えたいと言われたときに困るので、せめて開きなおせば直るという
     * ところまで担保する。だって提出量によっては向こうの計算大変だしー今時間ないしー
     * ****************************/
    if (this.sw.status === 'submitted') {
      let old_win_cnt = this.result.win_cnt // 勝ち数
      let old_trade_count = this.result.trade_count // トレードカウント
      let old_trade_edge = this.result.trade_edge // トレードエッジ
      let old_win_rate = this.result.win_rate // 勝率
      let old_accumulated_profit_loss = this.result.accumulated_profit_loss // 累計損益
      let old_lose_cnt = this.result.lose_cnt // 負け数
      let old_profit_average = this.result.profit_average // 利益平均
      let old_loss_average = this.result.loss_average // 損失平均
      let old_risk_reword_ratio = this.result.risk_reword_ratio // リスクリワード比率
      let old_percent_total_profit_loss = this.result.percent_total_profit_loss // 累計損益% ＋資金管理のみ

      // 再計算
      this.resultCalc()

      if (this.result.win_cnt !== old_win_cnt
        || this.result.trade_count !== old_trade_count
        || this.result.trade_edge !== old_trade_edge
        || this.result.win_rate !== old_win_rate
        || this.result.accumulated_profit_loss !== old_accumulated_profit_loss
        || this.result.lose_cnt !== old_lose_cnt
        || this.result.profit_average !== old_profit_average
        || this.result.loss_average !== old_loss_average
        || this.result.risk_reword_ratio !== old_risk_reword_ratio
        || this.result.percent_total_profit_loss !== old_percent_total_profit_loss)
      {
        // こっそり保存する
        this.secretlySave()
      }
    }

    loadingInstance.close()
  },
  methods: {
    initData() {
      // *--- スイッチ周り ---*
      this.sw.fmDialogVisible = false // step1入力ダイアログ
      this.sw.submitDialogVisible = false // 提出ダイアログ
      this.sw.trashDialogVisible = false // 破棄ダイアログ
      this.sw.helpVisible = false // ヘルプダイアログ
      this.sw.funds_management = false // + 資金管理
      this.sw.brandLoading = false // 銘柄ローディング
      this.sw.status = '' // 入力モード
      this.sw.stock_target = 1 // 投資対象
      // *--- + 資金管理 ---*
      this.fm.loss_cut_range = ''
      this.fm.my_funds = ''
      this.fm.unit_adjustment = ''
      // *--- 銘柄入力行 ---*
      this.brand.brand_code = ''
      this.brand.brand_name = ''
      this.brand.chart = ''
      this.brand.number_of_units = 0 // WC_SUPPORT-676にて廃止だが、過去のデータがあるので消せない
      // *--- fx銘柄用 ---*
      this.brand.atr = ''
      this.brand.kawase = 1
      this.brand.key_currency_code = 'なし'
      // *--- 仕掛け／手仕舞い入力 ---*
      this.inputStep2.step2_date = ''
      this.inputStep2.step2_time = ''
      this.inputStep2.step2_atr = ''
      this.inputStep2.step2_trading_volume = ''
      this.inputStep2.step2_trading = ''
      this.inputStep2.step2_price = ''
      this.inputStep2.step2_reason = ''
      this.inputStep2.step3_date = ''
      this.inputStep2.step3_time = ''
      this.inputStep2.step3_price = ''
      this.inputStep2.step3_reason = ''
      // *--- 提出後結果 ---*
      this.result.win_cnt = ''
      this.result.trade_count = ''
      this.result.trade_edge = ''
      this.result.win_rate = ''
      this.result.accumulated_profit_loss = ''
      this.result.lose_cnt = ''
      this.result.profit_average = ''
      this.result.loss_average = ''
      this.result.risk_reword_ratio = ''
      this.result.percent_total_profit_loss = ''
      // *--- 感想と備忘録 ---*
      this.appendix.memo = ''
    },
    initRow(rowId) {
      const id = (this.rows) ? rowId : 1

      return [{
        row_id: id, // 行ID
        step2_date: null, // 仕掛け日付
        step2_time: null, // 仕掛け時間
        step2_atr: 0, // 仕掛けATR(B)
        step2_trading_volume: 0, // 仕掛け取引量
        step2_trading: null, // 仕掛け買売
        step2_price: 0, // 仕掛け価格
        step2_reason: null, // 仕掛け理由
        loss_cut: 0, // ロスカット
        step3_date: null, // 手仕舞い日付
        step3_time: null, // 手仕舞い時間
        step3_price: 0, // 手仕舞い価格
        step3_reason: null, // 手仕舞い理由
        profit_loss_per_share: 0, // 獲得値幅
        pips: 0, // pips
        profit_loss_atr: 0, // 値幅/ATR
        trading_profit_loss: 0, // 取引損益
        balance: 0, // 残高
      }]
    },
    // *--- バリデーション判定 ---*
    // step1
    errorClassObject(iKey) {
      const ret = Object.keys(this.validation[iKey]).every(jKey => {
        return this.validation[iKey][jKey][0]
      })

      return {
        'has-error': ret === false
      }
    },
    // step2
    errorClassObjectStep2(iKey) {
      const ret = Object.keys(this.step2Validation[iKey]).every(jKey => {
        return this.step2Validation[iKey][jKey][0]
      })

      return {
        'has-error': ret === false
      }

    },
    // step3
    errorClassObjectStep3(iKey) {
      const ret = Object.keys(this.step3Validation[iKey]).every(jKey => {
        return this.step3Validation[iKey][jKey][0]
      })

      return {
        'has-error': ret === false
      }
    },
    /*************************************
     * 仕掛け 手仕舞い入力
     *************************************/
    step2Submit() {
      // バリデーション
      if (this.isValid === false) {
        ElMessage.error('エラー箇所を修正してください。')
        return
      }

      this.sw.status = 'step3'

      const index = this.latestRowIndex
      this.rows[index].step2_date = this.inputStep2.step2_date
      this.rows[index].step2_time = this.inputStep2.step2_time
      this.rows[index].step2_atr = this.inputStep2.step2_atr
      this.rows[index].step2_trading_volume = this.inputStep2.step2_trading_volume
      this.rows[index].step2_trading = this.inputStep2.step2_trading
      this.rows[index].step2_price = this.inputStep2.step2_price
      this.rows[index].step2_reason = this.inputStep2.step2_reason

      this.loss_cut_calc()

      this.inputStep3.step3_date = this.inputStep2.step2_date
      this.inputStep3.step3_time = this.inputStep2.step2_time
      this.clearStep2()
      // this.enter_active_class = "animated fadeInUp",
      // this.leave_active_class = "animated fadeOutUp"
    },
    step3Submit() {
      // バリデーション
      if (this.isValid === false) {
        ElMessage.error('エラー箇所を修正してください。')
        return
      }

      this.sw.status = 'step2'

      const index = this.latestRowIndex
      this.rows[index].step3_date = this.inputStep3.step3_date
      this.rows[index].step3_time = this.inputStep3.step3_time
      this.rows[index].step3_price = this.inputStep3.step3_price
      this.rows[index].step3_reason = this.inputStep3.step3_reason

      this.profit_loss_per_share_calc()
      this.pips_calc()
      this.profit_loss_atr_calc()
      this.trading_profit_loss_calc()
      this.balance_calc()

      this.rows.push(this.initRow(this.rows.length + 1)[0])

      this.inputStep2.step2_date = this.inputStep3.step3_date
      this.inputStep2.step2_time = this.inputStep3.step3_time
      this.clearStep3()
    },
    clearStep2() {
      for (let i in this.inputStep2) {
        if (i === 'step2_date') { continue }
        this.inputStep2[i] = ''
      }
    },
    clearStep3() {
      for (let i in this.inputStep3) {
        if (i === 'step3_date') { continue }
        this.inputStep3[i] = ''
      }
    },
    // 仕掛け入力に戻る
    backToTheStep2() {
      const index = this.latestRowIndex
      const initRow = this.initRow(index + 1)[0]
      // 入力エリアを戻す
      this.inputStep2['step2_date'] = this.rows[index]['step2_date']
      this.inputStep2['step2_time'] = this.rows[index]['step2_time']
      this.inputStep2['step2_atr'] = this.rows[index]['step2_atr']
      this.inputStep2['step2_trading_volume'] = this.rows[index]['step2_trading_volume']
      this.inputStep2['step2_trading'] = this.rows[index]['step2_trading']
      this.inputStep2['step2_price'] = this.rows[index]['step2_price']
      this.inputStep2['step2_reason'] = this.rows[index]['step2_reason']
      // 表を行単位でまっさら
      this.rows[index] = initRow

      this.sw.status = 'step2'
    },
    // 手仕舞い入力に戻る
    backToTheStep3() {
      if (this.latestRowIndex > 0) {
        // 末尾配列の削除
        this.rows.pop()

        const index = this.latestRowIndex
        const initRow = this.initRow()[0] // 全て使う訳じゃないのでrow_idは適当に取る
        // 入力エリアを戻す
        this.inputStep3['step3_date'] = this.rows[index]['step3_date']
        this.inputStep3['step3_time'] = this.rows[index]['step3_time']
        this.inputStep3['step3_price'] = this.rows[index]['step3_price']
        this.inputStep3['step3_reason'] = this.rows[index]['step3_reason']
        // 表の手仕舞いをまっさら
        this.rows[index]['step3_date'] = initRow.step3_date
        this.rows[index]['step3_time'] = initRow.step3_time
        this.rows[index]['step3_price'] = initRow.step3_price
        this.rows[index]['step3_reason'] = initRow.step3_reason

        this.sw.status = 'step3'
      }
    },
    /*************************************
     * 保存と提出と破棄ボタンたち
     *************************************/
    // *--- 保存処理 ---*
    async callSaveData() {
      // ただloadingでハンバーガーしたいだけ
      const loadingInstance = ElLoading.service()

      await this.saveData()

      loadingInstance.close()
    },
    saveData() {
      return new Promise((resolve, reject) => {
        const sdata = {
          funds_management: this.sw.funds_management,
          status: this.sw.status,
          stock_target: this.sw.stock_target,
          brand: this.brand,
          fm: this.fm,
          inputStep2: this.inputStep2,
          inputStep3: this.inputStep3,
          result: this.result,
          rows: this.rows,
          appendix: this.appendix,
        }

        axios
          .post('/practice-tool/save-practice/', sdata)
          .then(res => {
            this.saved_practice_id = res.data.saved_practice_id
            ElMessage.success('保存しました。')
            resolve('saved')
          })
          .catch(error => {
            console.error(error)
            ElMessage.error('保存できませんでした。')
            reject('unsaved')
            return
          })
      })
    },
    // 提出後の感想と備忘録更新用
    async updateData() {
      const loadingInstance = ElLoading.service()
      // 提出一覧から遷移すれば$routeから取れるが、提出直後は取れないためsaved_practice_idから取得する。
      const sdata = {
        practice_id: (this.$route.params.id > 0) ? this.$route.params.id : this.saved_practice_id,
        appendix: this.appendix,
      }
      await axios
        .post('/practice-tool/update-practice/', sdata)
        .then(res => {
          ElMessage.success('保存しました。')
        })
        .catch(error => {
          console.error(error)
          ElMessage.error('保存できませんでした。')
        })
      loadingInstance.close()
    },
    // *--- 提出処理 ---*
    submission() {
      if (this.latestRowIndex === 0) {
        ElMessage.error('１行以上入力をしてから提出してください。')
        this.sw.submitDialogVisible = false
        return
      }

      const loadingInstance = ElLoading.service()

      // 末尾行を削除
      const old_row = this.rows.pop()

      // 結果処理
      this.resultCalc()

      const old_status = this.sw.status
      this.sw.status = 'submitted'

      // 保存
      this.saveData()
        .then(p => {
          // 提出完了メッセージ
          ElMessageBox.alert(
            'おつかれさまでした。<br>'
            + '提出されたプラクティスは会員サイトメニューの「プラクティス一覧」からご覧いただくことができます。<br><br>'
            + '新しくプラクティスを開始するには、画面を更新していただくか、'
            + '会員サイトメニューの「プラクティスツール」を選択することで、いつでも始めることができます。',
            '提出が完了しました。',
            {
              dangerouslyUseHTMLString: true,
            }
          )
        })
        .catch(p => {
          // sw.status戻し
          this.sw.status = old_status
          // 行戻し
          this.rows.push(old_row)
          this.sw.submitDialogVisible = false
          loadingInstance.close()
          return
        })

      this.sw.submitDialogVisible = false
      loadingInstance.close()
    },
    // 結果処理
    resultCalc() {
      let win_cnt = 0,
        total_profit = 0,
        total_loss = 0,
        trade_edge = 0,
        trade_count = 0,
        win_rate = 0,
        accumulated_profit_loss = 0,
        lose_cnt = 0,
        profit_average = 0,
        loss_average = 0,
        risk_reword_ratio = 0,
        percent_total_profit_loss = 0

      // 勝ち数、負け数、トータル  損益0は含まない
      for (let i in this.rows) {
        if (this.rows[i].trading_profit_loss > 0) {
          win_cnt += 1
          total_profit += this.rows[i].trading_profit_loss
        }
        if (this.rows[i].trading_profit_loss < 0) {
          lose_cnt += 1
          total_loss += this.rows[i].trading_profit_loss
        }
      }
      // 利益平均 損失平均
      profit_average = (win_cnt > 0) ? this.orgRound(total_profit / win_cnt, 100) : 0
      loss_average = (lose_cnt > 0) ? this.orgRound(total_loss / lose_cnt, 100) : 0

      // トレードカウント
      trade_count = this.rows.length

      // 勝率 勝ち数 / 取引損益の数
      win_rate = this.orgRound(win_cnt / this.rows.length * 100, 100)

      // トレードエッジ
      trade_edge = this.orgRound(win_cnt / this.rows.length * profit_average - (1 - (win_cnt / this.rows.length)) * Math.abs(loss_average), 1)

      // リスクリワード
      risk_reword_ratio = (win_cnt > 0 && lose_cnt > 0) ? this.orgRound(total_profit / win_cnt / Math.abs(total_loss / lose_cnt), 100) : 0
      // 累計損益
      accumulated_profit_loss = total_profit + total_loss
      // 資金管理のみ
      if (this.sw.funds_management) {
        // 累計損益%
        percent_total_profit_loss = this.orgRound(
          accumulated_profit_loss / this.fm.my_funds * 100,
          100
        )
      }

      this.result.win_cnt = win_cnt // 勝ち数
      // this.result.total_profit = total_profit            // 利益合計
      // this.result.total_loss = total_loss              // 損失合計
      this.result.trade_count = trade_count // トレード回数
      this.result.trade_edge = trade_edge // トレードエッジ
      this.result.win_rate = win_rate // 勝率
      this.result.accumulated_profit_loss = accumulated_profit_loss // 累計損益 通常版のみ
      this.result.lose_cnt = lose_cnt // 負け数
      this.result.profit_average = profit_average // 利益平均
      this.result.loss_average = loss_average // 損失平均
      this.result.risk_reword_ratio = risk_reword_ratio // リスクリワード比率
      this.result.percent_total_profit_loss = percent_total_profit_loss // 累計損益% ＋資金管理のみ

    },
    // *--- 破棄処理 ---*
    async trash() {
      const loadingInstance = ElLoading.service()
      // saveがあれば削除
      await axios
        .get('/practice-tool/save-destroy')
        .catch(error => {
          console.error(error)
          ElMessage.error('保存データを削除できませんでした。')
          loadingInstance.close()
          return
        })

      // 画面データを初期化
      this.initData()
      // *--- 仕掛け／手仕舞い表部分 ---*
      // 壊レテしまわぬよう優しくセットする
      // 最後に新規行を追加
      this.rows.push(this.initRow(this.rows.length + 1)[0])
      // 最後の新規行以外は削除
      this.rows.splice(0, this.rows.length - 1)
      // id書き換え
      this.rows[0].row_id = 1

      loadingInstance.close()

      // ローディングの前面にダイアログが出てしまうのでローディング解除してからセット
      this.sw.status = 'step1'
    },
    // *--- こっそりセーブ ---*
    secretlySave() {
      const sdata = {
        practice_id: this.$route.params.id,
        result: this.result,
      }

      axios
        .post('/practice-tool/secret-save-practice/', sdata)
    },
    // *--- css ---*
    classCellColor(value, base) {
      if (value < base) {
        return { 'cel-danger': true }
      } else {
        return { 'cel-info': true }
      }
    },
    // *--- 四捨五入 ---*
    orgRound: (value, base) => {
      if (!base) { base = 1 }
      return Math.round(value * base) / base
    },
    // *--- 小数点の引き算をするメソッド ---*
    calcSubtract(value1, value2) {
      const max = Math.max(this.getDecimalLength(value1), this.getDecimalLength(value2))
      const k = Math.pow(10, max)
      return (this.multiply(value1, k) - this.multiply(value2, k)) / k
    },
    // *--- 小数点の乗算をするメソッド ---*
    multiply(value1, value2) {
      const intValue1 = +(value1 + '').replace('.', '')
      const intValue2 = +(value2 + '').replace('.', '')
      const decimalLength = this.getDecimalLength(value1) + this.getDecimalLength(value2)

      return (intValue1 * intValue2) / Math.pow(10, decimalLength)
    },
    // *--- 与えられた値の小数点以下の桁数を返す ---*
    getDecimalLength(value) {
      const list = (value + '').split('.')
      let result = 0
      if (list[1] !== undefined && list[1].length > 0) {
        result = list[1].length
      }
      return result
    },
    // *--- 買／売ラベルの取得 ---*
    fetchTradingLabel(value) {
      const find = this.trading_options.filter((item, index) => {
        if (item.value === value) { return true }
      })
      return (find[0]) ? find[0].label : ''
    },
    // *--- 初回ダイアログ入力完了処理 ---*
    fmSubmit() {
      this.sw.fmDialogVisible = false
      this.sw.status = 'step2'

      // 仕掛け日付と時刻のデフォルトセット
      const now = dayjs().format('YYYY-MM-DD')
      const nowTime = dayjs().format('HH:mm')
      this.inputStep2.step2_date = now
      this.inputStep2.step2_time = nowTime

    },
    // *--- 銘柄コードから情報取得 ---*
    brandCodeInput: async function(brand_code) {
      // this.brand.brand_name = this.brand.number_of_units = ''
      this.brand.brand_name = ''
      if (!!brand_code &&
                brand_code.length === this.validates.brand.brand_code_length)
      {
        this.sw.brandLoading = true
        await axios({
          method: 'GET',
          url: '/funds-management/fetch-stock/' + brand_code
        })
          .then(response => {
            if (response.data.error_msg !== '')
            {
              this.validation['brand_code'] = false
              ElMessage.error('情報を取得できませんでした。')
              this.sw.brandLoading = false
              return
            }
            this.brand.brand_name = response.data.brand_name
            // this.brand.number_of_units = response.data.number_of_units;
            ElMessage.success('銘柄：' + response.data.brand_name + '　最新日付：' + response.data.updated_at)
          })
          .catch(err => {
            this.validation['brand_code'] = false
            console.error(err)
            ElMessage.error('情報を取得できませんでした。')
          })
        this.sw.brandLoading = false
      }
    },
    fxBrandCodeInput: async function(brand_code) {
      if (
        !!brand_code &&
                brand_code.length === this.validates.brand.fx_brand_code_length
      ) {
        this.sw.brandLoading = true
        await axios.post('/practice-tool/fetch-fx-stock', {
          brand_code: brand_code
        })
          .then(response => {
            this.brand.brand_name = response.data[0].code_name
            this.brand.key_currency_code = response.data[0].key_currency_code
            this.brand.kawase = response.data[0].kawase
            ElMessage.success('銘柄：' + response.data[0].code_name + '　最新日付：' + response.data[0].date)
          })
          .catch(err => {
            this.validation['brand_code'] = false
            console.error(err)
            ElMessage.error('情報を取得できませんでした。')
          })
        this.sw.brandLoading = false
      }
    },
    currencyCodeInput: async function(brand_code) {
      if (
        !!brand_code &&
                brand_code.length === this.validates.brand.fx_brand_code_length
      ) {
        this.sw.brandLoading = true
        await axios.post('/practice-tool/fetch-currency-conversion', {
          brand_code: brand_code
        })
          .then(response => {
            // this.brand.brand_name = response.data[0].code_name;
            this.brand.kawase = response.data[0].kawase
            ElMessage.success('銘柄：' + response.data[0].code_name + '　最新日付：' + response.data[0].date)
          })
          .catch(err => {
            this.validation['brand_code'] = false
            console.error(err)
            ElMessage.error('情報を取得できませんでした。')
          })
        this.sw.brandLoading = false
      }
    },
    stockTargetInput() {
      if (this.sw.stock_target==1 || this.sw.stock_target==2) {
        this.brand.brand_code = ''
      }
      else if (this.sw.stock_target==3) {
        this.brand.brand_code = 'なし'
      }
      this.brand.brand_name = ''
      this.brand.kawase = 1
      this.brand.key_currency_code = 'なし'
    },
    // *--- 保存データの取得 ---*
    fetchData: async function(id) {
      const query = Object.assign({}, this.$route.query)
      let path = '/practice-tool/fetch-practice/' + id
      if (Object.keys(query).length) {
        if (query['uid'] && query['page']) {
          path = '/practice-tool/fetch-practice/' + id + '?page=' + query['page'] + '&role=admin&uid=' + query['uid']
        }
        else if (query['page']) {
          path = '/practice-tool/fetch-practice/' + id + '?page=' + query['page']
        }
        else if (query['uid']) {
          path = '/practice-tool/fetch-practice/' + id + '?role=admin&uid=' + query['uid']
        }
      }

      await axios.get(path)
        .then(async res => {

          // データさんがなかったです
          if (res.data.status == 'no_data') {
            // 未提出さんならstep1に、そうじゃないid指定付き（提出済み）は404ページに
            if (id === 'create') {
              this.sw.status = 'step1'
              return
            } else {
              this.$router.push('/error')
            }
          }

          // 単一データ部分のセット
          const practice = res.data.practice
          this.sw.status = practice.status
          this.sw.stock_target = practice.stock_target
          this.sw.funds_management = practice.funds_management
          // *--- + 資金管理 ---*
          this.fm.loss_cut_range = + practice.loss_cut_range // ロスカット N-ATR
          this.fm.my_funds = + practice.my_funds // 投資用資金
          this.fm.unit_adjustment = + practice.unit_adjustment // ユニットの調整（c）
          // *--- 銘柄入力行 ---*
          this.brand.brand_code = practice.brand_code // 銘柄コード
          this.brand.brand_name = practice.brand_name // 銘柄名
          this.brand.chart = + practice.chart // 足
          this.brand.number_of_units = + practice.number_of_units // 取引単位（単元数）   // WC_SUPPORT-676にて廃止だが、過去のデータがあるので消せない
          // *--- fx銘柄用 ---*
          this.brand.key_currency_code = practice.key_currency_code // 基軸通貨コード
          this.brand.kawase = practice.kawase // レート
          // *--- 仕掛け／手仕舞い入力 ---*
          this.inputStep2.step2_date = practice.input_step2_date // 仕掛け日付
          this.inputStep2.step2_time = practice.input_step2_time // 仕掛け時間
          this.inputStep2.step2_atr =
                    (practice.input_step2_atr == null)
                      ? null
                      : + practice.input_step2_atr // 仕掛けATR(B)
          this.inputStep2.step2_trading_volume =
                    (practice.input_step2_trading_volume == null)
                      ? null
                      : + practice.input_step2_trading_volume // 仕掛け取引量
          this.inputStep2.step2_trading =
                    (practice.input_step2_trading == null)
                      ? null
                      : + practice.input_step2_trading // 仕掛け買売
          this.inputStep2.step2_price =
                    (practice.input_step2_price == null)
                      ? null
                      : + practice.input_step2_price // 仕掛け価格
          this.inputStep2.step2_reason = practice.input_step2_reason // 仕掛け理由
          this.inputStep3.step3_date = practice.input_step3_date // 手仕舞い日付
          this.inputStep3.step3_time = practice.input_step3_time // 手仕舞い時間
          this.inputStep3.step3_price =
                    (practice.input_step3_price == null)
                      ? null
                      : + practice.input_step3_price // 手仕舞い価格
          this.inputStep3.step3_reason = practice.input_step3_reason // 手仕舞い理由
          // *--- 提出後結果 ---*
          this.result.win_cnt = + practice.win_cnt // 勝ち数
          // this.result.total_profit = + practice.total_profit            // 利益合計
          // this.result.total_loss = + practice.total_loss              // 損失合計
          this.result.trade_count = + practice.trade_count // トレードカウント
          this.result.trade_edge = + practice.trade_edge // トレードエッジ
          this.result.win_rate = + practice.win_rate // 勝率
          this.result.accumulated_profit_loss = + practice.accumulated_profit_loss // 累計損益 通常版のみ
          this.result.lose_cnt = + practice.lose_cnt // 負け数
          this.result.profit_average = + practice.profit_average // 利益平均
          this.result.loss_average = + practice.loss_average // 損失平均
          this.result.risk_reword_ratio = + practice.risk_reword_ratio // リスクリワード比率
          this.result.percent_total_profit_loss = + practice.percent_total_profit_loss // 累計損益% ＋資金管理のみ
          // *--- 提出したプラクティスに対する評価と講師コメント ---*
          this.evaluation = practice.evaluation
          this.instructor_comment = practice.instructor_comment

          // 複数データ部分のセット
          const bodys = res.data.bodys

          const rows = []
          for (let i in bodys) {
            let row = {
              row_id: bodys[i].row_id, // 行ID
              step2_date: bodys[i].step2_date, // 仕掛け日付
              step2_time: bodys[i].step2_time, // 仕掛け時間
              step2_atr: + bodys[i].step2_atr, // 仕掛けATR(B)
              step2_trading_volume: + bodys[i].step2_trading_volume, // 仕掛け取引量
              step2_trading: + bodys[i].step2_trading, // 仕掛け買売
              step2_price: + bodys[i].step2_price, // 仕掛け価格
              step2_reason: bodys[i].step2_reason, // 仕掛け理由
              step3_date: bodys[i].step3_date, // 手仕舞い日付
              step3_time: bodys[i].step3_time, // 手仕舞い時間
              step3_price: + bodys[i].step3_price, // 手仕舞い価格
              step3_reason: bodys[i].step3_reason, // 手仕舞い理由

              // 以下はプロパティ生成のためにセット。再計算される
              loss_cut: + bodys[i].loss_cut, // ロスカット
              profit_loss_per_share: + bodys[i].profit_loss_per_share, // 獲得値幅
              pips: + bodys[i].pips, // pips
              profit_loss_atr: + bodys[i].profit_loss_atr, // 値幅/ATR
              trading_profit_loss: + bodys[i].trading_profit_loss, // 取引損益
              balance: + bodys[i].balance, // 残高
            }

            rows.push(row)
          }

          this.rows = rows

          // *--- 感想と備忘録 ---*
          this.appendix.memo = practice.memo

        })
        .catch(error => {
          console.error(error)
          ElMessage.error('情報を取得できませんでした。')

          this.sw.status = 'step1'
        })

      await axios
        .get('/practice-tool/fetch-mfx-brands')
        .then(res => {
          this.m_fx_brands = res.data
        })
        .catch(error => {
          console.error(error)
          ElMessage.error('FX銘柄情報を取得できませんでした。')
        })
    },

    // *--- ロスカット計算 ---*
    loss_cut_calc() {
      const getDecimalLength = (num) => {
        const deci_num = String(num).split('.')
        const deci_len = (deci_num[1]) ? deci_num[1].length : 0
        return deci_len <= 10 ? deci_len : 10
      }
      for (let i in this.rows) {
        const deci_len = getDecimalLength(this.rows[i].step2_price)
        const org_round_data = this.org_round_list.find((v) => v.value === deci_len)
        if (this.rows[i].step2_price && this.rows[i].step2_atr && this.fm.loss_cut_range && this.rows[i].step2_trading) {
          this.rows[i].loss_cut = this.orgRound(
            this.rows[i].step2_price - (this.rows[i].step2_atr * this.fm.loss_cut_range * this.rows[i].step2_trading),
            org_round_data.base
          )
        } else {
          this.rows[i].loss_cut = 0
        }
      }
    },
    // *--- 獲得値幅計算 ---*
    profit_loss_per_share_calc() {
      for (let i in this.rows) {
        if (this.rows[i].step2_price && this.rows[i].step3_price && this.rows[i].step2_trading) {
          const result_subtract = this.calcSubtract(this.rows[i].step3_price, this.rows[i].step2_price)
          this.rows[i].profit_loss_per_share = result_subtract * this.rows[i].step2_trading
        } else {
          this.rows[i].profit_loss_per_share = 0
        }
      }
    },
    // *--- pips ---*
    pips_calc() {
      for (let i in this.rows) {
        if (this.rows[i].profit_loss_per_share) {
          if (this.brand.kawase==1) {
            this.rows[i].pips = this.rows[i].profit_loss_per_share * 100
          }
          else {
            this.rows[i].pips = this.rows[i].profit_loss_per_share * 10000
          }
        } else {
          this.rows[i].pips = 0
        }
      }
    },
    // *--- 値幅/ATR計算 ---*
    profit_loss_atr_calc() {
      for (let i in this.rows) {
        if (this.rows[i].profit_loss_per_share && this.rows[i].step2_atr) {
          this.rows[i].profit_loss_atr = this.orgRound(
            this.rows[i].profit_loss_per_share / this.rows[i].step2_atr,
            100
          )
        } else {
          this.rows[i].profit_loss_atr = 0
        }
      }
    },
    // *--- 取引損益計算 ---*
    trading_profit_loss_calc() {
      for (let i in this.rows) {
        if (this.rows[i].profit_loss_per_share && this.rows[i].step2_trading_volume) {
          this.rows[i].trading_profit_loss = this.orgRound(
            this.rows[i].profit_loss_per_share * this.brand.kawase * this.rows[i].step2_trading_volume,
            1
          )
        } else {
          this.rows[i].trading_profit_loss = 0
        }
      }
    },
    // *--- 残高計算 ---*
    balance_calc() {
      for (let i in this.rows) {
        // 以下、atrが0の場合に残高の積上が0になってしまったため修正。なぜatrで判断したか覚えてない。
        // if (this.fm.my_funds && this.rows[i].profit_loss_atr) {
        if (this.fm.my_funds) {
          this.rows[i].balance = (i == 0) ? this.fm.my_funds + this.rows[i].trading_profit_loss
            : this.rows[i - 1].balance + this.rows[i].trading_profit_loss
        } else {
          this.rows[i].balance = 0
        }
      }
    },

    // 数値にカンマを付与
    moneyDelimiter: (value) => {
      // return value.toString().replace(/(\d)(?=(\d{3})+$)/g, "$1,");
      return value.toLocaleString()
    },
    // 四捨五入を避ける
    notRoundMoneyDelimiter: (value) => {
      // return value.toString().replace(/(\d)(?=(\d{3})+$)/g, "$1,");
      return value.toLocaleString(undefined, { maximumFractionDigits: 10 })
    },

    getImage: (image) => {
      return image ? require(`@/assets/images/tools/practice/${image}`) : ''
    }
  },
  watch: {
    'sw.status'() {
      if (this.sw.status === 'step1') {
        this.sw.fmDialogVisible = true
      } else {
        this.sw.fmDialogVisible = false
      }
    }
  },
  components: {
    PracticeToolHelp
  }
}
</script>

<style scoped>
/* bootstrap css直書き */
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #eceeef;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #eceeef;
}

.table tbody + tbody {
  border-top: 2px solid #eceeef;
}

.table .table {
  background-color: #fff;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #eceeef;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #eceeef;
}

.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

.form-group {
  margin-bottom: 1rem;
}
</style>

<style scoped>
.practice-tool * {
  font-family: "游ゴシック Medium", "游ゴシック体", "Yu Gothic Medium", YuGothic, "ヒラギノ角ゴ ProN", "Hiragino Kaku Gothic ProN", "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-size: 20px !important;
}

.practice-tool {
  padding: 1rem;
}

.practice-tool .table-responsive.table-bordered {
  border: 0;
}

.practice-tool h4 {
  font-size: 30px !important;
}

.practice-tool h4 span.bold {
  font-weight: bold;
  font-size: 30px !important;
}

.practice-tool label {
  white-space: nowrap;
}

.practice-tool .no-wrap {
  white-space: nowrap;
}

.practice-tool .margin-right-10 {
  margin-right: 10px;
}

.practice-tool .margin-ud-10 {
  margin: 10px 0;
}

.practice-tool .text-red {
  color: red;
  text-shadow: 1px 1px 3px #000;
}

.practice-tool table.h-table {
  margin: 0 auto;
  width: 100%;
  border: none;
  border-collapse: separate;
}

.practice-tool table.h-table th {
  vertical-align: middle;
  height: 33%;
  text-align: right;
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
}

.practice-tool table.h-table td.data {
  padding: 0;
  border: none;
  font-size: 12px;
  line-height: 16px;
  text-align: left;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
}

.practice-tool table.h-table td:fst-child {
  padding: 0 0 0 10px;
  vertical-align: middle;
}

.practice-tool table.h-table th span {
  margin-right: 20px;
  margin-left: 5px;
}

.practice-tool table.h-table td span {
  margin-left: 20px;
  margin-right: 5px;
}

.practice-tool table.h-table td.bar {
  height: 1%;
  width: 100%;
  border-top: dotted 1px #827d7d;
}

.practice-tool table.h-table th.lbar {
  border-left: solid 1px #827d7d;
}

.practice-tool table.h-table th.rbar {
  border-right: dotted 1px #827d7d;
}

.practice-tool .fusen {
  width: 100%;
  /*幅はお好きなサイズに*/
  position: relative;
  z-index: 0;
}

.practice-tool .fusen table {
  font-size: 0.9em;
  margin: 0 0 1.5em 0;
  padding: 1em;
  position: relative;
  /* グラデーションで折り目がついた感じに */
  background: linear-gradient(to right, #ffffcc 0%, #f1f1c1 0.5%, #f1f1c1 13%, #ffffcc 16%);
}

.practice-tool .fusen table::after {
  /* ドロップシャドウを少し斜めに配置して、立体感を出す */
  content: "";
  display: block;
  position: absolute;
  z-index: -1;
  bottom: 5px;
  right: 0;
  height: 20px;
  width: 99%;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.3);
  transform: rotate(1deg);
}

.practice-tool .kokuban {
  color: #fff;
  background-color: #114400;
  margin: 10px 0 10px 0;
  padding: 15px;
  border: 9px solid #a60;
  border-radius: 3px;
  box-shadow: 2px 2px 4px #666, 2px 2px 2px #111 inset;
  line-height: 1.9;
}

.practice-tool .comment {
  background-color: #e2fde3;
  border: 1.5px dashed #dad9d8;
  box-shadow: 1px 1px 6px 0px #ccc;
  -moz-box-shadow: 1px 1px 6px 0px #ccc;
  -webkit-box-shadow: 1px 1px 6px 0px #ccc;
  -o-box-shadow: 1px 1px 6px 0px #ccc;
  padding: 45px 20px 20px 50px;
  position: relative;
  font-weight: bold;
  z-index: 0;
}

.practice-tool .comment:after {
  background-color: #05ab3a;
  background-image: linear-gradient(45deg, #5ba974 25%, transparent 25%, transparent 75%, #5ba974 75%, #5ba974), linear-gradient(45deg, #5ba974 25%, transparent 25%, transparent 75%, #5ba974 75%, #5ba974);
  background-position: 0 0, 12px 12px;
  background-size: 24px 24px;
  border-left: 2px dotted rgba(255, 255, 255, 0.9);
  border-right: 2px dotted rgba(255, 255, 255, 0.9);
  box-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
  content: "講師からのコメント";
  display: block;
  padding: 5px 20px;
  color: #fff;
  text-align: center;
  position: absolute;
  top: -10px;
  left: 20px;
  transform: rotate(-3deg);
  -moz-transform: rotate(-3deg);
  -webkit-transform: rotate(-3deg);
  -o-transform: rotate(-3deg);
}

.practice-tool .img-evaluation {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 180px;
}

.practice-tool table {
  border: 3px solid #000;
}

.practice-tool table thead tr th {
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
}

.practice-tool .border-right {
  border-right: 3px solid #000;
}

.practice-tool .cel-info {
  background-color: #e2e2e2;
}

.practice-tool .cel-danger {
  background-color: #ffd0d0;
  color: red;
}

.practice-tool .step2-color {
  background-color: #ff4756;
  color: #fff;
}

.practice-tool .step3-color {
  background-color: #2073ff;
  color: #fff;
}

.practice-tool .system-color {
  background-color: #2c3a6d;
  color: #fff;
}

.practice-tool .help-block {
  font-size: 11px;
}

.practice-tool .help-button {
  margin-left: 10px;
  padding: 10px 5px;
}

.practice-tool .fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.practice-tool .fade-enter, .fade-leave-to {
  opacity: 0;
}

.practice-tool .middle {
  width: 100%;
  height: 100%;
  display: table;
}

.practice-tool .middle .middle-inner {
  width: 100%;
  height: 100%;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.practice-tool .up {
  margin: auto;
  width: 0;
  height: 0;
  border: 60px solid transparent;
  border-bottom-color: #999;
}

.practice-tool .btn-center {
  width: 200px;
  margin: 0px auto;
}

.practice-tool .btn-center2 {
  width: 400px;
  margin: 0px auto;
}

.practice-tool .btn-right {
  width: 100px;
  margin: 3px 0 3px auto;
}

</style>